import { formatDistanceToNow } from 'date-fns';

export default class DateHelper {
  public static format(date: string): string {
    return new Date(date).toLocaleString('en-GB', {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).replace(/,/g, '');
  }

  public static formatRelative(date: Date | string): string {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return formatDistanceToNow(dateObj, { addSuffix: true });
  }
}
